import React, { useEffect, useState } from "react";
import { Upload, message, Select, Drawer, Tabs, DatePicker, Spin } from "antd";
import PropTypes from "prop-types";
// import { CloseOutlined } from "@ant-design/icons";
import { BASE_CRM_URL } from "../../../components/config/config";
import Swal from "sweetalert2";
import axios from "axios";
import dayjs from "dayjs";

const { Dragger } = Upload;

const NewExpense = ({
  open,
  onClose,
  getExpenses,
  customerId,
  type,
  onExpenseAdded,
}) => {
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userId = userDetails?.staffid;
  const isRelatedLocked = Boolean(type && customerId);

  console.log(isRelatedLocked, customerId, "expensescustomerid");

  const [formData, setFormData] = useState({
    reason: "",
    note: "",
    date: "",
    reference: "",
    amount: "",
    supplier: "",
  });

  const uploadProps = {
    name: "file",
    multiple: false,
    beforeUpload: (file) => {
      setFileList([file]);
      return false;
    },

    onRemove: () => {
      setFileList([]);
    },

    onChange(info) {
      setFileList(info.fileList);

      console.log("Selected file:", info.file);
      console.log("File list:", info.fileList);
    },

    onDrop(e) {
      console.log("Dropped files:", e.dataTransfer.files);
    },
  };
  const getDrawerWidth = () => {
    const width = window.innerWidth;

    if (width <= 576) {
      return "90%";
    }

    if (width <= 992) {
      return "60%";
    }

    if (width <= 1440) {
      return "45%";
    }

    return "20%";
  };

  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);

  const [taxOptions, setTaxOptions] = useState([]);
  const [taxLoading, setTaxLoading] = useState(false);
  const [selectedTax1, setSelectedTax1] = useState(null);
  const [selectedTax2, setSelectedTax2] = useState(null);

  const [expenseCatogryes, setExpenseCatogrys] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [selectedCategory, setSelectedcategory] = useState(null);

  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [projectOptions, setProjectOptions] = useState([]);
  const [projectLoading, setProjectLoading] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  const [paymentOptions, setPaymentOptions] = useState([]);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);

  const getTaxes = async () => {
    try {
      setTaxLoading(true);

      const response = await fetch(`${BASE_CRM_URL}GetTaxes`);

      const data = await response.json();

      if (data.Status) {
        const options = (data.ResultData || []).map((item) => ({
          value: item.Id,
          label: item.Name,
          taxrate: Number(item.taxrate || 0),
        }));

        setTaxOptions(options);
      } else {
        setTaxOptions([]);
      }
    } catch (error) {
      console.error("Error fetching taxes:", error);
      setTaxOptions([]);
    } finally {
      setTaxLoading(false);
    }
  };

  const getExpenseCatogery = async () => {
    setCategoryLoading(true);
    try {
      const response = await fetch(
        `${BASE_CRM_URL}expenses/GetExpenseCategories`,
      );
      const data = await response.json();
      if (data?.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setExpenseCatogrys(options);
      } else {
        setExpenseCatogrys([]);
      }
    } catch (error) {
      console.error("Error fetching categories", error);
    } finally {
      setCategoryLoading(false);
    }
  };

  const getCustomers = async () => {
    setCustomerLoading(true);
    try {
      const response = await fetch(`${BASE_CRM_URL}customers/GetCustomers`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.customerId,
          label: item.company,
        }));

        setCustomerOptions(options);
      }
    } catch (error) {
      console.error("Error fetching related types:", error);
    } finally {
      setCustomerLoading(false);
    }
  };

  const getProjects = async (customerId) => {
    try {
      setProjectLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}project/GetProjectsByCusId?CusID=${customerId}`,
      );

      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setProjectOptions(options);
      } else {
        setProjectOptions([]);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
      setProjectOptions([]);
    } finally {
      setProjectLoading(false);
    }
  };

  const getPaymentMode = async () => {
    setPaymentLoading(true);
    try {
      const response = await fetch(`${BASE_CRM_URL}expenses/GetPaymentModes`);
      const data = await response.json();
      if (data?.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setPaymentOptions(options);
      } else {
        setPaymentOptions([]);
      }
    } catch (error) {
      console.error("Error fetching categories", error);
    } finally {
      setPaymentLoading(false);
    }
  };

  useEffect(() => {
    getTaxes();
    getExpenseCatogery();
    getCustomers();
    getPaymentMode();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    console.log(customerId, "eeeeeeeeeeeeeeeeeeeeeeeeeeeee");
    if (customerId && customerOptions.length > 0) {
      const customer = customerOptions.find(
        (item) => Number(item.value) === Number(customerId),
      );

      console.log(customer, "unkowncolumnnnnnnnnnnnnnnn");
      if (customer) {
        setSelectedCustomer(customer?.value);
        getProjects(customer?.value);
      }
    }
  }, [customerId, customerOptions]);

  const basicContent = (
    <div>
      <Dragger {...uploadProps}>
        <div className="d-flex justify-content-center align-items-center">
          <p className="ant-upload-drag-icon me-2 mb-0">
            <i className="fa-brands fa-dropbox text-secondary fs-2"></i>
          </p>

          <p className="ant-upload-text mb-0">
            Click or drag file to this area to upload Receipts
          </p>
        </div>
      </Dragger>

      <div className="row pt-3">
        <div className="col-6 mb-3">
          <label className="form-label">Expense Category</label>

          <Select
            placeholder="Select Expense Category"
            style={{ width: "100%", height: 38 }}
            allowClear
            showSearch
            optionFilterProp="label"
            loading={categoryLoading}
            options={expenseCatogryes}
            value={selectedCategory}
            onChange={(value) => {
              setSelectedcategory(value);
            }}
          />
        </div>

        <div className="col-6 mb-3">
          <label className="form-label">Expense Date</label>

          <DatePicker
            format="DD-MM-YYYY"
            className="form-control"
            value={formData.date ? dayjs(formData.date) : null}
            onChange={(date) => {
              handleInputChange({
                target: {
                  name: "date",
                  value: date ? date.format("YYYY-MM-DD") : "",
                },
              });
            }}
          />
        </div>
        <div className="col-12 mb-3">
          <label className="form-label">Reason</label>

          <input
            type="text"
            className="form-control"
            placeholder="Enter expense reason"
            name="reason"
            value={formData.reason}
            onChange={handleInputChange}
          />
        </div>

        <div className="col-6 mb-3">
          <label className="form-label">Amount</label>

          <input
            type="number"
            className="form-control"
            placeholder="Enter amount"
            name="amount"
            value={formData.amount}
            onChange={handleInputChange}
            min="0"
            step="0.01"
          />
        </div>

        {/* Supplier */}

        <div className="col-6 mb-3">
          <label className="form-label">Supplier</label>

          <input
            type="text"
            className="form-control"
            placeholder="Enter supplier"
            name="supplier"
            value={formData.supplier}
            onChange={handleInputChange}
          />
        </div>
        <div className="col-6 mb-3">
          <label className="form-label">Customer</label>

          <Select
            placeholder="Select Customer"
            style={{ width: "100%", height: 38 }}
            allowClear
            showSearch
            optionFilterProp="label"
            loading={customerLoading}
            options={customerOptions}
            value={selectedCustomer}
            onChange={(value) => {
              setSelectedCustomer(value);
              getProjects(value);
            }}
            disabled={isRelatedLocked}
          />
        </div>
        {selectedCustomer && (
          <div className="col-6 mb-3">
            <label className="form-label">Project</label>

            <Select
              placeholder="Select Project"
              style={{ width: "100%", height: 38 }}
              allowClear
              showSearch
              optionFilterProp="label"
              loading={projectLoading}
              options={projectOptions}
              value={selectedProject}
              onChange={(value) => {
                setSelectedProject(value);
              }}
            />
          </div>
        )}
        {/* Note */}

        <div className="col-12 mb-3">
          <label className="form-label">Note</label>

          <textarea
            className="form-control"
            rows={3}
            placeholder="Enter note"
            name="note"
            value={formData.note}
            onChange={handleInputChange}
          />
        </div>
      </div>
    </div>
  );

  const advancedContent = (
    <div className="row">
      <div className="col-6 mb-3">
        <label className="form-label">Tax 1</label>

        <Select
          className="w-100"
          placeholder="Select Tax"
          loading={taxLoading}
          options={taxOptions}
          value={selectedTax1}
          onChange={(value) => {
            setSelectedTax1(value);
          }}
          style={{ height: 38 }}
          allowClear
        />
      </div>

      {/* Tax 2 */}

      <div className="col-6 mb-3">
        <label className="form-label">Tax 2</label>

        <Select
          className="w-100"
          placeholder="Select Tax"
          style={{ height: 38 }}
          options={taxOptions}
          loading={taxLoading}
          value={selectedTax2}
          onChange={(value) => {
            setSelectedTax2(value);
          }}
          allowClear
        />
      </div>

      {/* Payment Mode */}

      <div className="col-6 mb-3">
        <label className="form-label">Payment Mode</label>

        <Select
          placeholder="Select Payment Type"
          style={{ width: "100%", height: 38 }}
          allowClear
          showSearch
          optionFilterProp="label"
          options={paymentOptions}
          loading={paymentLoading}
          value={selectedPayment}
          onChange={(value) => {
            setSelectedPayment(value);
          }}
        />
      </div>

      {/* Reference */}

      <div className="col-6 mb-3">
        <label className="form-label">Reference #</label>

        <input
          type="text"
          className="form-control"
          placeholder="Enter reference number"
          name="reference"
          value={formData.reference}
          onChange={handleInputChange}
        />
      </div>
    </div>
  );

  const [activeTab, setActiveTab] = useState("basic");

  const handleNext = () => {
    setActiveTab("advanced");
  };

  const handleReset = () => {
    setActiveTab("basic");

    setFormData({
      reason: "",
      note: "",
      date: "",
      reference: "",
      amount: "",
      supplier: "",
    });

    setSelectedPayment(null);
    setSelectedcategory(null);
    setSelectedTax2(null);
    setSelectedTax1(null);
    setSelectedCustomer(null);
    setSelectedProject(null);
    onClose();
  };

  // const handleSave = async (e) => {
  //   e.preventDefault();
  //   try {
  //     setLoading(true);
  //     const payload = {
  //       category: selectedCategory,
  //       clientid: selectedCustomer,
  //       tax: selectedTax1,
  //       tax2: selectedTax2,
  //       paymentmode: selectedPayment,
  //       amount: formData.amount ? Number(formData.amount) : 0,
  //       currency: 5,
  //       note: formData.note,
  //       expense_name: formData.reason,
  //       project_id: selectedProject,
  //       date: formData.date,
  //       send_invoice_to_customer: 0,
  //       addedfrom: userId,
  //       reference: formData.reference,
  //     };

  //     console.log("Expense payload:", payload);

  //     const response = await axios.post(
  //       `${BASE_CRM_URL}expenses/AddExpense`,
  //       payload,
  //     );

  //     if (response.data?.Status) {
  //       Swal.fire({
  //         title: "Success",
  //         text: response.data?.Message || "Expense added successfully",
  //         icon: "success",
  //         confirmButtonText: "OK",
  //       }).then(async (result) => {
  //         if (result.isConfirmed) {
  //           if (onExpenseAdded) {
  //             await onExpenseAdded();
  //           } else {
  //             await getExpenses();
  //           }
  //           handleReset();
  //           // onClose();
  //         }
  //       });
  //     } else {
  //       Swal.fire({
  //         title: "Error",
  //         text: "Failed to add Expense",
  //         icon: "error",
  //         confirmButtonText: "OK",
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Save Expense Error:", error);

  //     message.error("Failed to save expense");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSave = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const payload = new FormData();

      payload.append("category", selectedCategory || "");
      payload.append("currency", 5);
      payload.append("amount", formData.amount || 0);
      payload.append("tax", selectedTax1 || 0);
      payload.append("note", formData.note || "");
      payload.append("expense_name", formData.reason || "");
      payload.append("clientid", selectedCustomer || "");
      payload.append("project_id", selectedProject || "");
      payload.append("paymentmode", selectedPayment || "");
      payload.append("date", formData.date || "");
      payload.append("send_invoice_to_customer", 0);
      payload.append("addedfrom", userId || "");
      payload.append("tax2", selectedTax2 || 0);
      payload.append("reference", formData.reference || "");
      payload.append("supplier", formData.supplier || "");

      // File
      if (fileList.length > 0) {
        fileList.forEach((file) => {
          payload.append("file", file.originFileObj);
        });
      }

      console.log("Expense FormData:");

      for (const [key, value] of payload.entries()) {
        console.log(key, value);
      }

      const response = await axios.post(
        `${BASE_CRM_URL}expenses/AddExpense`,
        payload,
      );

      if (response.data?.Status) {
        Swal.fire({
          title: "Success",
          text: response.data?.Message || "Expense added successfully",
          icon: "success",
          confirmButtonText: "OK",
        }).then(async (result) => {
          if (result.isConfirmed) {
            if (onExpenseAdded) {
              await onExpenseAdded();
            } else {
              await getExpenses();
            }

            handleReset();
          }
        });
      } else {
        Swal.fire({
          title: "Error",
          text: response.data?.Message || "Failed to add Expense",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Save Expense Error:", error);
      message.error("Failed to save expense");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <Drawer
        title="Add Expense"
        placement="right"
        open={open}
        onClose={handleReset}
        width={getDrawerWidth()}
        destroyOnClose
        styles={{
          body: {
            paddingTop: 0,
          },
        }}
        closable={false}
        extra={
          <div className="d-flex justify-content-end gap-2">
            {/* <Button type="text" icon={<CloseOutlined />} onClick={onClose} /> */}

            <button
              type="button"
              onClick={handleReset}
              disabled={loading}
              className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
              style={{
                width: "35px",
                height: "35px",
                backgroundColor: "#e40d22",
                color: "#fff",
                border: "none",
              }}
              title="Close"
            >
              <i className="fa fa-times" />
            </button>

            {activeTab === "basic" ? (
              // <Button type="primary" onClick={handleNext}>
              //   Next
              // </Button>

              <button
                type="button"
                onClick={handleNext}
                className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                style={{
                  width: "35px",
                  height: "35px",
                  backgroundColor: "#f1f51e",
                  color: "#fff",
                  border: "none",
                }}
                title="Next"
              >
                <i className="fa fa-arrow-right" />
              </button>
            ) : (
              // <Button type="primary" loading={loading} onClick={handleSave}>
              //   Save
              // </Button>

              <button
                type="button"
                onClick={handleSave}
                disabled={loading}
                className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                style={{
                  width: "35px",
                  height: "35px",
                  backgroundColor: "#07f083",
                  color: "#fff",
                  border: "none",
                }}
                title="Save"
              >
                {loading ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                  />
                ) : (
                  <i className="fa fa-check" />
                )}
              </button>
            )}
          </div>
        }
        // footer={
        //   <div className="d-flex justify-content-end">
        //     <Button className="me-2" onClick={onClose} disabled={loading}>
        //       Close
        //     </Button>
        //   </div>
        // }
      >
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={[
            {
              key: "basic",
              label: "Basic",
              children: basicContent,
            },
            {
              key: "advanced",
              label: "Advanced",
              children: advancedContent,
            },
          ]}
        />
      </Drawer>
    </div>
  );
};
NewExpense.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  getExpenses: PropTypes.func.isRequired,
  customerId: PropTypes.number.isRequired,
  onExpenseAdded: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default NewExpense;
